<div class="portfolio-equivalents-com">

  <div class="block">
    Select a security, then select the securities and categories to be considered as equivalents and alternatives. These settings will override and/or supplement your existing security or model rules for equivalents and alternatives.
  </div>

  <div class="block">
    <irb-expando-link text="How do equivalents and alternatives work in iRebal?">
      <strong>Equivalents</strong>
      <div class="block">
        Select the securities considered "equivalent" to a security when calculating a portfolio's allocations. Equivalent securities will not be purchased in place of each other, but can be sold.
      </div>

      <strong>Alternatives</strong>
      <div>iRebal will purchase a designated security instead of another if you already possess it in your account, known as an "Alt if Held" security. If you specify multiple alternatives, iRebal will purchase whichever one there's more of in the account.</div>
    </irb-expando-link>
  </div>

  <div class="portfolio-equivalents-com-counters block">
    {{ securityCount }} equivalent securities, {{ heldCount }} alt if held, {{ categoryCount }} equivalent category
  </div>

  <div class="portfolio-equivalents-com-selection block">
    <div style="padding-right: 14px;border-right: 1px solid #c8c8c8;">
      <div><strong>Target Security</strong></div>
      <div>
        <irb-dropdown-search #securitiesDropdownEl (search)="populateTargetSecurities($event)"
          (selection)="selectTargetSecurity($event)"
          (clearSelection)="clearTargetSecurity()"
          [addNewItem]="addNewPfTargetEquivalentSecurityItem"
          (openNewItemFlow)="openNewTargetSecurityFlow($event)"
          size="16" hoverPanelWidth="165"
        ></irb-dropdown-search>
      </div>
    </div>

    <div style="padding-left: 12px;">
      <div><strong>Equivalents and Alternatives</strong></div>
      <div style="display: flex;">
        <div style="padding-right: 8px;padding-top: 2px;">Type</div>
        <div style="padding-right: 10px;">
          <irb-dropdown-filter #selectTypeDropdown placeholder="-No filter-"
            [value]="typeDropdownSelected"
            (search)="populateTypeDropdown($event)"
            size="16"
            hoverPanelWidth="160"
          (selection)="setEquivalentType($event)"></irb-dropdown-filter>
        </div>
        <div>
          @if (equivalentType === 'security') {
            <irb-dropdown-search-multiple width="150"
              #securityEquivalentsDropdown (search)="populateSecurityEquivalentsMultiple($event)"
              [enableHiddenSearchResults]="false"
              [enableEmptySearchTerm]="true" showApplyButton="true"
              [values]="selectedEquivalentSecurity"
              placeholder="Search for a security"
              [addNewItem]="addNewPfEquivalentSecurityItem"
              (openNewItemFlow)="openNewEquivalentSecurityFlow($event)"
            (selection)="onSelectSecurityEquivalents($event)"></irb-dropdown-search-multiple>
          }
          @if (equivalentType === 'category') {
            <irb-dropdown-search-multiple width="150"
              #categoryEquivalentsDropdown (search)="populateCategoryEquivalentsMultiple($event)"
              [enableHiddenSearchResults]="false"
              [enableEmptySearchTerm]="true" showApplyButton="true"
              [values]="selectedCustomCategory"
              placeholder="Search for a category"
              [addNewItem]="addNewPfCategoryItem"
              (openNewItemFlow)="openNewPfCategoryFlow($event)"
            (selection)="onSelectCategoryEquivalents($event)"></irb-dropdown-search-multiple>
          }
        </div>
        <div>
          <button [disabled]="isAddButtonDisabled"
          class="btn-medium-secondary btn-spacer" (click)="onAddEquivalent()">Add</button>
        </div>
        <div class="portfolio-equivalents-com-advanced" [class]="!selectedTargetSecurity? 'pe-not-active-filter' : ''">
          <a  class="nav-link-text" (click)="showAddMultipleSecuritiesDialog()">Advanced Filter</a>
        </div>
        <div style="padding-left: 10px;padding-top: 2px;">
          <p-checkbox binary="true" [(ngModel)]="altIfHeld"
            [disabled]="isAltIfHeldDisabled"
            inputId="peitem1">
          </p-checkbox>
          <label for="peitem1">Alt if Held</label>
        </div>
      </div>
    </div>
  </div>

  <div class="portfolio-equivalents-com-grid block">
    @if (!isUiTest) {
      <irb-inventory-grid
        [style.width]="'100%'"
        [gridHeight]="gridHeight"
        [showSideBar]="false"
        [gridOptions]="gridOptions"
        [frameworkComponents]='frameworkComponents'
      (gridReady)="onGridReady($event)"></irb-inventory-grid>
    }
  </div>
  @if (modelId) {
    <div>
      <a  class="nav-link-text" (click)="viewPortfolioModel()">View model equivalents and alternatives</a>
    </div>
  }

</div>
